/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsFromJSONTyped, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsToJSON, } from './FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions';
export function FxIdWebFeaturesStoreCreatePaymentRequestPlutusFromJSON(json) {
    return FxIdWebFeaturesStoreCreatePaymentRequestPlutusFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreCreatePaymentRequestPlutusFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions(json)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesStoreCreatePaymentRequestPlutusToJSON(json) {
    return FxIdWebFeaturesStoreCreatePaymentRequestPlutusToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreCreatePaymentRequestPlutusToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions(value)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesStoreCreatePaymentRequestPlutus.js.map